import { css } from '@emotion/core'

export const textWrap = css`
  label {
    overflow-wrap: anywhere;
  }
`
